import { Col, Flex, Row } from 'antd'

/**
 * returns JSX for assigning teachers
 */
function AssignTeachers() {
  return (
    <>
      {/* navigation */}
      <Flex vertical gap="20px">
        <Row gutter={10} className="main-navigation">
          <Col>
            <Flex
              gap="10px"
              className="main-navigation__heading"
              align="center"
            >
              <h3>Assign Teachers</h3>
            </Flex>
          </Col>
        </Row>
      </Flex>
    </>
  )
}

export default AssignTeachers
